import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';

var DEFAULT_ITEM_TMPL = '<i class="{{icon}}" data-id="{{id}}"></i>';
var SELECTED_CLASS = 'selected';
export default Marionette.View.extend({
    tagName: 'li',
    template: Handlebars.compile(DEFAULT_ITEM_TMPL),
    serializeData: function() {
        return _.defaults(this.model.toJSON(), {
            icon: 'fa fa-cube'
        });
    },
    modelEvents: {
        'change:selected': 'on_change_selected'
    },
    events: {
        'click': 'on_click'
    },
    on_change_selected: function(nav_item) {
        if (nav_item.get('selected')) {
            this.select();
        } else {
            this.deselect();
        }
    },
    on_click: function() {
        this.$el.tooltip('hide');
        var action = this.model.get('action');
        if (_.isFunction(action)) {
            action.call(this);
        } else {
            console.warn('Action is not a function');
        }
    },
    select: function() {
        this.$el.addClass(SELECTED_CLASS);
    },
    deselect: function() {
        this.$el.removeClass(SELECTED_CLASS);
    },
    onRender: function() {
        if (this.model.get('selected')) {
            this.select();
        }
        this.apply_tooltip();
    },
    apply_tooltip: function() {
        var title = this.model.get('title');
        if (!title) return;
        this.$el.tooltip({
            html: true,
            placement: 'right',
            delay: { 'show': 500, 'hide': 100 },
            title: title
        });
    }

});

